import React from 'react';
import Swal from 'sweetalert2';
import axios from "axios";
import PropTypes from "prop-types";
import Translate from "./utils";
import {injectIntl} from "react-intl";

function DeleteButton(props) {
    const {itemName = 'this', module, itemId, removeItemInListing, intl,} = props
    const handleOnClick = () => {

        Swal.fire({
            text: `${intl.formatMessage({id: "DIALOG.DELETE.QUESTION"})} '${itemName}'`,
            showCancelButton: true,
            icon: 'warning',
            confirmButtonText: `${intl.formatMessage({id: "DIALOG.DELETE.YES"})}`,
            confirmButtonColor: 'rgb(195, 46, 149)',
            cancelButtonColor: 'rgb(56, 6, 40)',
            cancelButtonText: `${intl.formatMessage({id: "DIALOG.DELETE.NO"})}`,
            showLoaderOnConfirm: true,
            allowOutsideClick: () => !Swal.isLoading(),
            preConfirm: (del) => {
                if (del) {
                    return handleDelete().catch(() => {
                        Swal.fire({
                            icon: 'error',
                            text: `${intl.formatMessage({id: "DIALOG.MESSAGE.ERROR"})}`
                        });
                        return false;
                    });
                }
                return false;
            },
        }).then(response => {
            //check if user did not press cancel or dismiss the alert dialog
            if (response.dismiss === undefined) {
                const {value: {status}} = response;
                if (status === 200) {
                    removeItemInListing(itemId);
                    Swal.fire({
                        icon: 'success',
                        text: `${intl.formatMessage({id: "DIALOG.MESSAGE.SUCCESS"})}`
                    });
                    return;
                }

                Swal.fire({
                    icon: 'error',
                    text: `${intl.formatMessage({id: "DIALOG.MESSAGE.ERROR"})}`
                });
            }
        });

    };

    const handleDelete = async () => {
        return await axios.delete(`${process.env.REACT_APP_API_BASE_TEST}/${module}/${itemId}`);
    };

    return (
        <button type="button" className='button-edit-delete' onClick={handleOnClick}>
            {<Translate id={"TABLE.ACTIONS.DELETE"}/>}
        </button>
    );
}

DeleteButton.propTypes = {
    itemId: PropTypes.number.isRequired,
    itemName: PropTypes.string.isRequired,
    module: PropTypes.string.isRequired,
};

export default injectIntl(DeleteButton);
